import React from 'react';
import { Toaster } from 'react-hot-toast';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import Services from './components/sections/Services';
import CaseStudies from './components/sections/CaseStudies';
import ContactCTA from './components/sections/ContactCTA';

function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <CaseStudies />
        <ContactCTA />
      </main>
      <Footer />
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#1A1D29',
            color: '#fff',
            border: '1px solid #3D5AF1',
          },
        }}
      />
    </div>
  );
}

export default App;